import { z } from 'zod';
import { decodeCsv } from './csv.js';

/**
 * Envuelve el schema de un elemento para que acepte lo que llega de la URL (`"a,b"`),
 * lo que llega de un `navigate` en código (`["a","b"]`) y la ausencia (`undefined`).
 * Sin esto cada ruta repetiría el mismo `preprocess`.
 */
export const csvList = <T extends z.ZodTypeAny>(item: T) =>
  z.preprocess(toList, z.array(item).optional());

const toList = (value: unknown): unknown => {
  if (typeof value === 'string') {
    // `?state=` sin valor significa "sin filtro", no "una lista con la cadena vacía".
    return value === '' ? undefined : decodeCsv(value);
  }
  return value;
};
